const headingCls = "c2lh1pj77ok";
const descriptionCls = "c2ldiujgw3";
const formCls = "c2lf1lpdy8f";
const buttonsCls = "c2lbtn5lp9";

export { buttonsCls, descriptionCls, formCls, headingCls };
import "./base-panel.style.linaria.module.css";
//# sourceMappingURL=base-panel.style.js.map
